import React from 'react'
import QRCode from 'qrcode.react'

import { URL_CONST } from 'utils/urlConsts'
import {
  required as requiredValidation,
  stringMinLength as stringMinLengthValidation,
  validateAll,
} from 'utils/validations'

import { LOGIN_STEPS } from 'containers/Login/constants'

import CenteredLoader from 'components/lib/CenteredLoader'

import Input from './Input'

const MAP_TITLE_BY_STEP = {
  [LOGIN_STEPS.TFA_PAIRING_STEP]: 'Enable Two-Factor Authentication',
  [LOGIN_STEPS.TFA_TOKEN_STEP]: 'Two-Factor Authentication',
}

export default class TwoFactor extends React.Component {
  state = {
    token: '',

    validations: {
      token: '',
    },
  }

  v = {
    token: {
      name: 'token',
      validator: (value) =>
        validateAll([requiredValidation(value), stringMinLengthValidation(6)(value)]),
    },
  }

  componentDidMount() {
    const { loginStep, fetch2FA } = this.props
    if (loginStep === LOGIN_STEPS.TFA_PAIRING_STEP) {
      fetch2FA()
    }
  }

  isFormValid = () => {
    const validators = [this.v.token]
    const currentValidation = {}

    validators.forEach((e) => {
      const error = e.validator(this.state[e.name])
      currentValidation[e.name] = error
    })

    this.setState({ validations: currentValidation })

    return !Object.keys(currentValidation).filter((e) => currentValidation[e]).length
  }

  submitForm = () => {
    const { token } = this.state
    const { submit2FA } = this.props
    if (!this.isFormValid()) return
    submit2FA({ twoFA_token: token })
  }

  handleKeydown = (e) => {
    if (e.keyCode === 13) this.submitForm()
  }

  handleInputOnChange = (e) => {
    const value = e.target.value
    this.setState({ token: value }, () => {
      if (value.length === 6) {
        this.submitForm()
      }
    })
  }

  render() {
    const { token, validations } = this.state
    const {
      loginStep,

      tfaParingUrl,

      SubmitButton,
    } = this.props

    return (
      <div onKeyDown={this.handleKeydown}>
        <h4>{MAP_TITLE_BY_STEP[loginStep]}</h4>
        {loginStep === LOGIN_STEPS.TFA_PAIRING_STEP && (
          <>
            <p>
              Please use your smartphone to scan the QR code below. Then, enter the token generated
              by the app (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.google.com/search?q=google+authenticator+app"
              >
                Google Authenticator
              </a>
              )
            </p>

            {tfaParingUrl ? (
              <QRCode value={tfaParingUrl} />
            ) : (
              <div style={{ padding: '50px' }}>
                <CenteredLoader />
              </div>
            )}
          </>
        )}
        <Input.Field
          id="TwoFactor_Token_input"
          value={token}
          name="token"
          type="text"
          autoFocus
          placeholder="2FA Token"
          autoComplete="off"
          onChange={this.handleInputOnChange}
          meta={{
            error: validations.token,
            touched: true,
          }}
        />
        <a className="fr" href={URL_CONST.login.resetToken}>
          Can't find the token?
        </a>
        <SubmitButton text="Submit" onClick={this.submitForm} />
      </div>
    )
  }
}
